import React, { PureComponent } from 'react';
import EventScrollableList from './EventScrollableList';
import { strings } from 'APP_ROOT/localization';
import Protected from 'APP_ROOT/components/common/protected';

// NOTE: This is very similar to the class in the dashboard page
// changes here should be reflected there as well
export default class EventSection extends PureComponent {

    render() {

        return (
            <div className="col-12 event-panel" id={this.props.id}>
                <div className="row section-wrapper">
                    <div className="col-12 section-header">
                        <h3>{strings.formatString(strings.events_title)}</h3>
                        <div className="events-actions">
                            <Protected 
                                resource="ravens.video_stream" 
                                action="view" 
                                gate={this.props.features?.historical_streaming && this.props.cardVideoAvailabilityStartDate}
                                resourceId={this.props.ravenUuid}
                            >
                                <button className="btn btn-outline-blue btn-sm btn-close-event" onClick={this.props.toggleEnhancedVideoAccessModeActive}>
                                    <i className="material-icons">play_circle_outline</i> {strings.vehicle_details_request_video}
                                </button>
                            </Protected>

                            <button className="btn btn-outline-blue btn-sm btn-close-event" onClick={this.props.print}>
                                <i className="material-icons">print</i> {strings.action_summary}
                            </button>
                        </div>
                    </div>
                    <div className="col-12 section-body">
                        <EventScrollableList
                            id={this.props.id}
                            ravenUuid={this.props.ravenUuid}
                            events={this.props.events}
                            card={this.props.card} /* for segments, speedZones */
                            unitOfMeasure={this.props.unitOfMeasure}
                            selectedEvent={this.props.selectedEvent}
                            onSelectEvent={this.props.onSelectEvent}
                            mediaRequestType={this.props.mediaRequestType}
                            renderForDashboard={this.props.renderForDashboard}
                            allSupportedEvents={this.props.allSupportedEvents}
                        />
                    </div>
                    <div className="section-btns">
                        {this.props.selectedEvent ?
                            <button className="btn btn-outline-blue btn-sm btn-close-event" onClick={(e) => this.props.onSelectEvent(null)}>
                                <i className="material-icons">close</i>{strings.formatString(strings.db_close_event_media)}
                            </button> : null}
                    </div>
                </div>
            </div>
        );
    }
}
